import "jquery-ui/ui/widgets/tabs";
import "jquery.cookie";
import moment from "moment";

export default function($app) {
	const self = this;

	const $ui = $app.require('ui');
	const $player = $app.require('player');
	const $locale = $app.require('locale');

	const currentTime = ko.observable(moment().unix());
	setInterval(function() { currentTime(moment().unix()) }, 500);
	self.isClosed = ko.observable(false);
	self.timeStart = ko.computed(() => {
		if($app.episode()) {
			return $app.episode().timeStart();
		}
		return $app.event().timeStart();
	});
	self.timeUntilStart = ko.computed(()  => self.timeStart() - currentTime());
	self.timeUntilStartFormatted = ko.computed(function() {
		const time = self.timeUntilStart();
		const timeSign = time < 0 ? '-' : '';
		const d = Math.floor(time / (3600*24)),
			h = Math.floor(time % (3600*24) / 3600),
			m = Math.floor(time % (3600) / 60),
			s = time % 3600 % 60,
			r = [];

		d && r.push(d + ` <span class="countdown-item-label">${$locale.getDate(d, 'days')}</span>`);
		h && r.push(h + ` <span class="countdown-item-label">${$locale.getDate(h, 'hours')}</span>`);
		(h || m) && r.push((m < 10 && r.length ? '0' + m : m) + ` <span class="countdown-item-label">${$locale.getDate(m, 'minutes')}</span>`);
		r.push((s < 10 && r.length ? '0' + s : s) + ` <span class="countdown-item-label">${$locale.getDate(s, 'seconds')}</span>`);
		return timeSign + r.join(' ');

		//return JSON.stringify({d:d,h:h,m:m,s:s});
	});

	self.nextEpisodeList = ko.computed(function() {
		if($app.currentStream()) {
			const nextEpisodes = $app.currentStream().episode().filter(episode => episode.type() === 'idle');
			if(nextEpisodes.length) {
				return nextEpisodes;
			}
		}

		if($app.event().status() === 'stop') {
			return $app.event().episode()
				.filter(episode => episode.type() === 'idle')
				.sort((a, b) => a.timeStart() - b.timeStart())
				;
		}
//		if(!$app.currentStream() || !$app.currentStream().episode) return [];
//		return $app.currentStream().episode().filter(episode => episode.type() === 'idle');
		return [];
	});

	self.nextEpisode = ko.computed(function() {
		const episodeList = self.nextEpisodeList();
		return episodeList.length ? episodeList[0] : null;
	});

	self.isShowTimeout = ko.computed(function() {
		const untilStart = self.timeUntilStart();
		let timeout = parseInt($app.event().moduleBranding.welcomePageTimeout());
		timeout = timeout && !isNaN(timeout) ? timeout : 24;
		return untilStart > 0 && untilStart <= 3600*timeout;
	});

	self.isIdle = ko.computed(function() {
		self.isClosed(false);
		return $app.event().status() === 'idle'
			|| ($app.event().status() === 'live' && !$app.isEventStarted())
			|| ($app.episode() && $app.episode().type() === 'idle')
			;
	});
	self.isStopped = ko.computed(function() {
		self.isClosed(false);
		return ($app.event().status() === 'stop' || ($app.currentStream() && $app.currentStream().status() === 'stop'))
			;
	});
	self.isPaused = ko.computed(function() {
		self.isClosed(false);
		return ($app.currentStream() && $app.currentStream().status() === 'pause')
//			|| (!$app.currentStream() && !self.isIdle() && !self.isStopped())
			;
	});

    self.isShare = ko.computed(function () {
        return $app.event().moduleBranding.share() && !$app.event().private();
    });

	self.status = ko.computed(function() {
		if(self.isIdle()) return 'idle';
		if(self.isPaused()) return 'pause';
		if(self.isStopped()) return 'stop';
		return 'live';
	});

	self.hasStartedStream = ko.computed(function() {
		let firstLiveStream = null,
			firstPauseStream = null,
			firstRecordStream = null;

		$app.event().stream().forEach(function(stream) {
			if(!firstLiveStream && in_array(stream.status(), ['live'])) {
				firstLiveStream = stream;
			} else if(!firstPauseStream && in_array(stream.status(), ['pause'])) {
				firstPauseStream = stream;
			} else if(!firstRecordStream && stream.dvr() && in_array(stream.status(), ['stop'])) {
				firstRecordStream = stream;
			}
		});

		return firstLiveStream || firstPauseStream || firstRecordStream;
	});

	self.isShowIdle = ko.computed(function() {
		return self.isIdle()
			// && !self.isClosed()
			&& $app.event().moduleBranding.welcomePage()
		;
	});
	self.isShowPause = ko.computed(function() {
		return self.isPaused()
			&& !self.isClosed()
			&& $player.live()
		;
	});
	self.isShowStop = ko.computed(function() {
		return self.isStopped()
			&& !$app.currentStream()
//			&& (!$app.currentStream() || $player.live())
//			&& (!$app.currentStream() || $app.currentStream().manualStatusControl())
//			&& ($app.event().manualStatusControl())
//			&& !self.isClosed()
//			&& !$app.event().stream()[0].dvr()
		;
	});

	self.isShow = ko.computed(function() {
		return self.isShowIdle()
			|| self.isShowPause()
			|| self.isShowStop()
			|| (self.hasStartedStream() && !$app.currentStream())
		;
	});

	self.hide = function() {
		self.isClosed(true);
	};

	self.notificationSubscribe = new NotificationSubscribe($app, self);

	$player.on('ended', function() { self.isClosed(false); });

	self.currentType = ko.observable('record');
	self.episodeList = ko.computed(function() {
		return $app.event().episode().filter(function(episode) {
			return episode.type() === self.currentType();
		});
	});

	function EpisodeType(title, type) {
		const episodeType = this;
		const tabIndex = ['record', 'live', 'idle'].indexOf(type);

		episodeType.title = ko.observable(title);
		episodeType.type = ko.observable(type);

		episodeType.episodeList = ko.computed(function() {
			return $app.event().episode().filter(function(episode) {
				if(episode.isDelay()) return false;
				return episode.type() === episodeType.type();
			}).sort(function(a, b) { return a.timeStart() - b.timeStart(); });
		});

		episodeType.isEnabled = ko.computed(function() { return episodeType.episodeList().length > 0; });

		episodeType.scrollPosition = ko.observable(0);
		episodeType.hasScrollLeft = ko.observable(false);
		episodeType.hasScrollRight = ko.observable(true);
		episodeType.onClickScrollRight = function(context, event) {
			let scroll = episodeType.scrollPosition() + 250;
			const container = $(event.target).parent().find('.slider-wrapper');
			let containerWidth = 0;
			container.children().each(function() { containerWidth += $(this).outerWidth(true); });
			const maxScroll = containerWidth - container.outerWidth(true);
			scroll = scroll > maxScroll ? maxScroll : scroll;
			episodeType.hasScrollRight(scroll < maxScroll);
			episodeType.hasScrollLeft(scroll > 0);
			episodeType.scrollPosition(scroll);
		};
		episodeType.onClickScrollLeft = function() {
			let scroll = episodeType.scrollPosition() - 250;
			scroll = scroll < 0 ? 0 : scroll;
			episodeType.hasScrollRight(true);
			episodeType.hasScrollLeft(scroll > 0);
			episodeType.scrollPosition(scroll);
		};

		episodeType.updateTabVisible = function() {
			const $tabs = $('.pause-episode-list');
			$tabs.tabs();
			$tabs.tabs(episodeType.isEnabled() ? 'enable' : 'disable', tabIndex);
			$tabs.tabs('refresh');
			setTimeout(function() {
				if($tabs.tabs('option', 'active') === tabIndex) {
					let index = 1;
					if(!self.episodeTypes()[1].isEnabled()) {
						index = 2;
						if(!self.episodeTypes()[2].isEnabled()) {
							index = 3;
						}
					}
					$tabs.tabs('option', 'active', index);
				}
			}, 0);
		};

		episodeType.isEnabled.subscribe(function() { episodeType.updateTabVisible(); });
		setTimeout(function() { episodeType.updateTabVisible(); }, 0);
	}
	self.episodeTypes = ko.observableArray([
		new EpisodeType('Записи', 'record'),
		new EpisodeType('Сейчас в эфире', 'live'),
		new EpisodeType('Далее', 'idle')
	]);
	self.eventEpisodeRecord = self.episodeTypes()[0].episodeList;
	self.eventEpisodeCurrent = self.episodeTypes()[1].episodeList;
	self.eventEpisodeAnnounce = self.episodeTypes()[2].episodeList;


	self.isShowTestSystem = ko.computed(function() {
		return $app.event().moduleBranding.testSystemLink();
	});
	self.isShowEpisodeListButton = ko.computed(function() {
		return $app.event().stream().length > 1 && $app.event().episode().length && $ui.playerSize.isCompact();
	});

	let playHandler = () => $app.currentStream($app.event().stream()[0]);

	self.setPlayHandler = (handler, timeout) => {
		playHandler = handler;
		self.autoPlayTimeout(typeof timeout !== 'undefined' ? timeout : 5000);
	};
	self.onClickPlayButton = () => {
//		self.isClosed(true);
		playHandler();
	};
	self.isShowPlayButton = ko.computed(() => {
		return self.hasStartedStream() && !self.isPaused() && !self.isIdle() && ($app.event().stream().length === 1);
	});
	self.autoPlayTimeout = ko.observable(0);

    this.isDownloadCalendarAvailable = ko.computed(() => !$app.event().private() && $app.event().moduleBranding.calendarButton());
    this.downloadCalendarUrl = ko.computed(() => `/api/player/event/${$app.event().eventKey()}/calendar.ics`);
	self.addCalendar = new function() {
		this.google = function() {
			const redirectUri = 'https://' + location.hostname + '/api/player/event/' + $app.event().id() + '/calendar.google';
			const clientId = '290739042565-2cj4jqn10a9pu5omrs8ddfehlkn44tnj.apps.googleusercontent.com';
			const scope = 'https://www.googleapis.com/auth/calendar';
			const link = 'https://accounts.google.com/o/oauth2/auth?redirect_uri=' + encodeURIComponent(redirectUri) + '&response_type=code&client_id=' + encodeURIComponent(clientId) +'&scope=' + encodeURIComponent(scope);
			$.cookie('google_calendar_event', $app.event().id(), {path: '/'});
			window.open(link,'Добавить в календарь',
				'toolbar=no,' +
				'location=no,' +
				'status=no,' +
				'menubar=no,' +
				'scrollbars=yes,' +
				'resizable=yes,' +
				'width=400px,' +
				'height=400px'
			);
		};
	};

	$app.on('start', function() {
		setTimeout(function() {
			ko.computed(function() {
				self.isShowPause();
				let index = 1;
				if(!self.episodeTypes()[1].isEnabled()) {
					index = 2;
					if(!self.episodeTypes()[2].isEnabled()) {
						index = 3;
					}
				}
				$('.pause-episode-list').tabs({
					hide: 'fade',
					show: 'fade',
					active: index
				});
			}, 100);
		});
	});
};

function NotificationSubscribe(/*$app, $overlay*/) {
	this.isShow = ko.observable(false);
	this.show = () => this.isShow(true);
	this.hide = () => this.isShow(false);

	this.type = ko.observable('calendar');
	this.setType = (type) => this.type(type);

}
